import { Badge } from "@shared/ui";

const ListItem = ({ itemHeader, itemId, itemLink, itemDetails, badge }) => {
  return (
    <div className="flex flex-row gap-x-4 pt-3 first:pt-0">
      <div className="flex flex-col flex-grow">
        {badge && (
          <div className="mb-2">
            <Badge status={badge} withIcon={true} />
          </div>
        )}
        <div className="flex flex-row justify-between">
          <h3 className="text-sm font-medium">{itemHeader}</h3>
          <h3 className="text-xs text-gray-500 bg-gray-50 hover:text-black hover:bg-gray-100 px-2 py-1 transition rounded-sm">
            {itemLink ? (
              <a href={itemLink} target="_blank">
                {itemId}
              </a>
            ) : (
              <>{itemId}</>
            )}
          </h3>
        </div>
        <div className="flex flex-row flex-wrap gap-x-1">
          {itemDetails
            .flat()
            .filter((i) => i)
            .map((item) => (
              <span className="text-sm after:content-['•'] after:ml-1 last:after:content-[''] last:after:ml-0">
                {item}
              </span>
            ))}
        </div>
      </div>
    </div>
  );
};

export default ListItem;
